// 20250705: xt grok  replaced the old class comp with this functional comp
// 20250801: xt chat upgraded from react-bootstrap to bootstrap 5.3.3 (replaced the Alert tag)
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './Notification.css';

const Notification = ({ text, type = 'info', show, onDismiss }) => {
 // console.log ("in notification need type= ", type);
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        //console.log('[Notification.js] Auto-dismissing with id:', text);
        onDismiss();
      }, 3000);
      return () => clearTimeout(timer); // Cleanup to prevent memory leaks
    }
  }, [show, onDismiss, text]);

  if (!show || !text) {
    console.log('[Notification.js] No show or text, returning null');
    return null;
  }

  console.log('[Notification.js] Rendering with text:', text, 'type:', type);

  return (
    <div
      className={`alert alert-${type} alert-dismissible fade show text-center mx-auto`}
      role="alert"
      id="update-notice"
      style={{ maxWidth: '600px' }}
    >
      <p className="mb-0">{text}</p>
      <button
        type="button"
        className="btn-close"
        aria-label="Close"
        onClick={onDismiss}
      ></button>
    </div>
  );
};

Notification.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string, // Bootstrap alert types: 'success', 'danger', etc.  show: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
};

export default Notification;